import { Accordion, Button, Form, Spinner } from "react-bootstrap";
import { useCreateOffer, useGetSentOffers } from "../../../api/query_hooks/offer";
import SentOfferDetails from "./SentOfferDetails";
import { useState } from "react";

const SentOffersPanel = ({id="", request={}, offers=[]}) => {

    const [price, setPrice] = useState(0);

    const offersQuery = useGetSentOffers(request.id);
    const createOfferQuery = useCreateOffer();

    const createOffer = (e) => {
        e.preventDefault();

        createOfferQuery.mutate({
            requestId: request.id,
            price: price
        });
    }


    return (
        <>
            {offersQuery.isLoading &&
                <div className='bg-dark flex-center gap-2 col-7 h-100 rounded-bottom m-auto'>
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {offersQuery.isError &&
                <div className='bg-dark flex-center gap-2 col-7 h-100 rounded-bottom m-auto'>
                    {offersQuery.error.response?.data}
                </div>
            }
            { offersQuery.isSuccess &&
                <div id={id} className="bg-darker d-flex flex-column flex-grow-1 mx-3 mb-2 rounded border border-2 border-black">
                    <div className="d-flex col-12 border-bottom border-2 border-black">
                        <p className="text-mini user-select-none flex-center col-12 m-0">Offers</p>
                    </div>
                    {offersQuery.data?.data.length ?
                        <Accordion className="flex-grow-1">
                            {offers.map((offer, index) => (
                                <SentOfferDetails key={index} eventKey={index} offer={offer} />
                            ))}
                        </Accordion>
                    :
                        <div className="d-flex flex-center flex-column h-100">
                            <box-icon color='white' size='md' type='solid' name='x-circle'></box-icon>
                            <p className="m-1 text-mini">No offers have been made yet</p>
                        </div>
                    }
                    {request.status === "PENDING" &&
                        <Form onSubmit={createOffer} className="flex-between px-5 py-1 border-top border-2 border-black">
                            <span className="">New offer:</span>
                            <Form.Group className="col-10 col-lg-8" controlId="passwordBox">
                                <Form.Control type="text" placeholder="Price" onChange={e => setPrice(e.target.value)} className="bg-darker bg-dark p-1 px-3" />
                            </Form.Group>

                            <Button variant="warning" type="submit" className="py-1">
                                Place offer
                            </Button>
                        </Form>
                    }
                </div>
            }
        </>
    );
};


export default SentOffersPanel;